import { useTranslation } from 'react-i18next';
import { Icon, Typography, useTheme } from '../../../../base';
import { StyledEmptyStateWrapper } from './TimeToHireEmptyState.styles';

const TimeToHireEmptyState = () => {
    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <StyledEmptyStateWrapper>
            <Icon name="NoTrackableDataIconBig" size={96} color="primary" />
            <Typography variant="h5">
                {t('reportsPage.timeToHireReport.noChartData.title')}
            </Typography>
            <Typography variant="body1" color={theme.palette.grey[600]}>
                {t('reportsPage.timeToHireReport.noChartData.description')}
            </Typography>
        </StyledEmptyStateWrapper>
    );
};

export default TimeToHireEmptyState;
